/** 扫码登录初始化与最终回执；回执不参与凭据持久化、不重放兑换。 */
export interface QrLoginCompletion {
  request: (action: string, body: Record<string, unknown>) => Promise<unknown>;
  initialize: (payload: Record<string, unknown>) => Promise<void>;
  isCurrent: () => boolean;
}

/** 仅重试幂等回执，串行退避且有次数上限；换平台立即停止，不影响已成功的登录。 */
async function reportResult(api: QrLoginCompletion, code: string, receipt: string, outcome: string): Promise<void> {
  if (!/^[a-f0-9]{64}$/.test(receipt)) return; // 旧平台没有回执能力，不能编造成功状态。
  for (let attempt = 0; attempt < 4 && api.isCurrent(); attempt++) {
    try {
      await api.request('complete', { code, receipt, outcome });
      return;
    } catch {
      if (attempt < 3 && api.isCurrent()) await new Promise(resolve => setTimeout(resolve, 1000 * 2 ** attempt));
    }
  }
}

/** 组件因登录成功卸载后仍允许回执送达；失败只回报初始化失败，不撤销其他登录。 */
export async function finishQrLogin(api: QrLoginCompletion, code: string, payload: Record<string, unknown>): Promise<void> {
  const { qr_receipt: receipt, ...loginData } = payload;
  if (!api.isCurrent()) throw new Error('平台已切换，请重新登录');
  try {
    await api.initialize(loginData);
  } catch (error) {
    void reportResult(api, code, String(receipt ?? ''), 'failed');
    throw error;
  }
  void reportResult(api, code, String(receipt ?? ''), 'completed');
}
